import React from 'react';
import { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Footer = () => {

  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

    useEffect(() => {
        Aos.init({ duration: 1000 });
      }, []);

  return (
    <div className='font-inria text-white bg-[#4E4E4E] w-full' >
      <div className='flex justify-between mx-10'>
      <div className='flex justify-center' >
        <h1 className='text-xl mt-6 mb-4 md:text-xl'> &copy; {currentYear} Siri Chandhana. All rights reserved.</h1>
      </div>
      <div className='flex justify-end'>
          <h1 className='text-xl mt-6 mb-4 md:text-xl'>Developed with 🤍 by <span className='font-extrabold text-[#E4B379]'>SIRI</span></h1>
      </div>
      {/* <div className='flex justify-center cursor-pointer' onClick={scrollToTop} id='bounce'> */}
       {/* <a><img className='my-1' src={top} alt='top'/></a>  */}
       {/* <svg className='my-1' xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 72 72"><path fill="#3f3f3f" d="M35.991 14L23 28.516h9.527L32.69 40h6.793l-.027-11.484h9.526z"/><path fill="none" stroke="#eeee" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M35.991 14L23 28.516h9.527L32.69 40h6.793l-.027-11.484h9.526zm.339 41.47a3.57 3.57 0 0 1-3.571-3.571V49.04a3.57 3.57 0 0 1 3.571-3.571h0a3.57 3.57 0 0 1 3.571 3.571v2.86a3.57 3.57 0 0 1-3.571 3.571M24.143 45.5h5.714M27 45.5v10m16.142-.03v-10h3.813a2.49 2.49 0 0 1 2.49 2.49h0a2.49 2.49 0 0 1-2.49 2.491h-3.813"/></svg>
      </div> */}
      </div>
    </div>
  )
}

export default Footer
